import * as React from "react";
import PatientsCreatePage from "../../../paitents_detils/pages/PatientsCreatePage";


export default function StaffDetailsPage() {
  return (
    <>
    <PatientsCreatePage/> 
    </>
  );
}
